var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_material-email",
    "data-name": "Icon material-email",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.27,
    height: 32.215,
    viewBox: "0 0 40.27 32.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-email-2",
    "data-name": "Icon material-email",
    d: "M39.243,6H7.027A4.022,4.022,0,0,0,3.02,10.027L3,34.188a4.039,4.039,0,0,0,4.027,4.027H39.243a4.039,4.039,0,0,0,4.027-4.027V10.027A4.039,4.039,0,0,0,39.243,6Zm0,8.054L23.135,24.121,7.027,14.054V10.027L23.135,20.094,39.243,10.027Z",
    transform: "translate(-3 -6)",
    fill: "#f7f2ee"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact1);
export default __webpack_public_path__ + "static/media/contact1.5e3370ba.svg";
export { ForwardRef as ReactComponent };